<template>
  <div
    v-if="loaded"
  >
    <div
      class="header blur"
      style="height: 400px;"
    >
      <div
        v-if="playlist.image"
        :style="{ backgroundImage: 'url(' + playlist.image + ')' }"
        class="bg-image"
      />
      <div
        v-if="!playlist.image"
        class="bg-image"
      />
    </div>
    <div class="container">
      <div class="columns is-vcentered">
        <div class="column is-6">
          <h2 class="subtitle is-marginless text color-red">
            {{ playlist.tracks.length }} tracks
          </h2>
          <h1 class="title is-1 text color-white">
            {{ playlist.name }}
          </h1>
          <p
            v-if="playlist.description"
            class="text extra-large color-bluegrey4"
            style="max-height: 120px; overflow: hidden;"
          >
            {{ playlist.description }}
          </p>
        </div>
        <div class="column" />
        <div class="column is-narrow">
          <img
            style="max-height: 216px;"
            :src="playlist.image"
          >
        </div>
      </div>
      <div class="box is-large">
        <h3 class="title is-3">
          Tracks
        </h3>
        <track-list-item
          v-for="track in playlist.tracks"
          :key="track.pk"
          :track="track"
        />
      </div>
    </div>
  </div>
</template>

<script>
import sharedPlaylistsClient from '@/api/sharedPlaylists.js'
import TrackListItem from '@/components/TrackListItem.vue'

export default {
  name: 'SharedPlaylistDetail',

  components: {
    TrackListItem
  },

  props: {
    privatePlaylistId: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      loaded: false,
      playlist: null
    }
  },

  created () {
    // Check vuex cache first.
    this.playlist = this.$store.getters['playlists/getPlaylistFromPrivateId'](this.privatePlaylistId)

    // If not, load this playlist data.
    if (this.playlist === null) {
      sharedPlaylistsClient.retrieve(this.privatePlaylistId)
        .then((response) => {
          this.playlist = response.data
          if (this.playlist.tracks.length > 0) {
            this.$store.dispatch('player/loadTracks', this.playlist.tracks)
          }
          this.loaded = true
        })
        .catch(error => {
          if (error.response.status === 404) {
            this.$router.push({ name: 'not-found' })
          }
        })
    } else {
      this.loaded = true
      if (this.playlist.tracks.length > 0) {
        this.$store.dispatch('player/loadTracks', this.playlist.tracks)
      }
    }
  },

  metaInfo () {
    if (this.playlist) {
      const title = `${this.playlist.name} | Music Licensing`

      return {
        title
      }
    } else {
      return {
        title: 'Music Licensing'
      }
    }
  }
}
</script>

<style>

</style>
